export default __webpack_public_path__ + "assets/pdfs/Salih_Khan_Tech.3ae5b300.pdf";